<template>
  <div id="reportContent">
    <header>
      <section id="title">
        <article id="reportInfo" class="text-center">
          <h2>{{ currentItem.centerName }}</h2>
          <h2 class="text-uppercase">
            Student Training Achievement Record Report
          </h2>
        </article>
      </section>
      <section id="student-info">
        <article>
          <h5>Student Name</h5>
          <p>{{ $store.getters.reportName }}</p>
        </article>
        <article>
          <h5>Student ID</h5>
          <p>{{ $store.getters.studId }}</p>
        </article>
        <article>
          <h5>Student Counselor</h5>
          <p>{{ currentItem.staffName }}</p>
        </article>
      </section>
      <section id="tar-info">
        <article>
          <h5>TAR Name</h5>
          <p>{{ currentItem.tarDesc }}</p>
        </article>
        <article>
          <h5>TAR Code</h5>
          <p>{{ currentItem.tarCode }}</p>
        </article>
        <article>
          <h5>TAR Status</h5>
          <p>{{ currentItem.tarStatus }}</p>
        </article>
        <article>
          <h5>TAR Begin Date</h5>
          <p>{{ formatDisplayDate(currentItem.beginDt) }}</p>
        </article>
        <article>
          <h5>TAR End Date</h5>
          <p>{{ formatDisplayDate(currentItem.endDt) }}</p>
        </article>
      </section>
    </header>
    <!-- TODO: Replace table with simple data table. MN -->
    <table>
      <thead>
        <tr>
          <th>Training Achievement Record Items</th>
          <th width="64"></th>
          <th>Rating</th>
          <th>Completion Date</th>
          <th>Proficiency Attained</th>
          <th>Student Acknowledgement</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in reportData" :key="data.tarDetailId">
          <td :class="styleTarDescription(data)">
            {{ data.tarDetailDescNoHtmlTags }}
          </td>
          <td>
            <span v-if="data.tarDetAttribCd == 4742">Green</span>
            <span v-if="data.tarDetAttribCd == 7491">NGBS</span>
          </td>
          <td>{{ data.ratingCd }}</td>
          <td>{{ formatDisplayDate(data.staffCompDt) }}</td>
          <td>{{ formatDisplayDate(data.staffSignoffDt) }}</td>
          <td>{{ formatDisplayDate(data.studentSignoffDt) }}</td>
        </tr>
      </tbody>
    </table>
    <footer>
      <article>
        <p>
          <strong>Instructor Signature:</strong>
          <span v-if="currentItem.staffName && currentItem.maxStaffSignOffDt">
            Electronically Signed By {{ currentItem.staffName }} on
            {{ formatDisplayDate(currentItem.maxStaffSignOffDt) }}
          </span>
        </p>
      </article>
      <article>
        <p>
          <strong>Manager Signature:</strong>
          <span v-if="currentItem.managerName && currentItem.mgrSignoffDt">
            Electronically Signed By {{ currentItem.managerName }} on
            {{ formatDisplayDate(currentItem.mgrSignoffDt) }}
          </span>
        </p>
      </article>
    </footer>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { formatDisplayDate } from '@/util/formatters'

export default {
  name: 'EtarReport',
  components: {},
  props: {
    reportData: {
      type: Array,
      required: true,
    },
    currentItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('etar', ['etarList']),
  },
  methods: {
    formatDisplayDate,
    // Table styling - MN
    styleTarDescription(item) {
      if (this.reportData.length > 1) {
        if (item.parentId == 0) return 'font-weight-bold'
        else if (item.tarChildLevel > 0)
          return `ml-${item.tarChildLevel + 1} d-block`
      }
    },
  },
}
</script>
<style lang="scss">
// Display and Print
#reportContent {
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
    'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important;
  color: #000 !important;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: #000;
    font-size: 0.9rem !important;
  }
  header {
    padding-bottom: 1rem;
    border-bottom: 2px solid #000;
    margin-bottom: 1rem;
    color: #000 !important;
    section {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      padding: 20px 0;
      &:last-child {
        padding-bottom: 0;
      }
    }
    #title {
      font-size: 0.9rem !important;
      font-weight: bold;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      padding: 20px 0;
      &:last-child {
        padding-bottom: 0;
      }
      #reportInfo {
        grid-column-start: 2;
        grid-column-end: 6;
      }
    }
  }
  table {
    width: 100%;
    font-size: 0.75rem;
    tbody td {
      padding: 4px;
      text-align: center;
      min-width: 64px;
      &:first-child {
        text-align: left;
      }
    }
    .v-badge__badge .secondary {
      border: 1px solid var(--v-secondary-base) !important;
      color: var(--v-secondary-base) !important;
      background: none !important;
    }
  }
  footer {
    margin: 20px 0;
  }
  #tar-info {
    article {
      padding-right: 1em;
    }
  }
}
</style>
